import React from 'react'
import iconDots from 'images/icons/dots.svg'
import mediaPlanPlaceholder from 'images/placeholders/media-plan.png'
import NumberFormat from 'react-number-format'
import { CSSTransition } from 'react-transition-group'
import { NumberFormatOptions } from '../../../helpers/const'
import Very from "../../../helpers/request_wrapper";

class MediaPlan extends React.Component {
  constructor(props) {
    super(props);
    this.state = { boxMenuVisible: false };
  }

  hideBoxMenu = () => {
    this.setState({ boxMenuVisible: false })
  };

  toggleBoxMenu = () => {
    this.setState({ boxMenuVisible: !this.state.boxMenuVisible })
  };

  unlockMediaplan = () => {
    Very.post(`/media_plans/${this.props.mediaPlan.id}/unlock`).then(res => {
      window.location.replace(`/media_plans/${this.props.mediaPlan.id}`)
    }, error => {

    })
  };

  render() {
    const { boxMenuVisible } = this.state;
    const { mediaPlan, canUnlock } = this.props;
    return (
      <React.Fragment>
        <CSSTransition
          in={boxMenuVisible}
          classNames="fade"
          timeout={600}
          unmountOnExit
        >
          <div
            className="bg-wild-sand-o-50 bottom-0 fixed left-0 right-0 top-0 z6"
            onClick={this.hideBoxMenu}
          />
        </CSSTransition>

        <div className="col-6 last-element-no-margin mb-50 md-col-12 px-25">
          <div className="box-shadow-box border border-gallery p-20 relative rounded-6">
            <p className="fs-11 mb-30 sfpro-regular">Created on {mediaPlan.created_at} {mediaPlan.persona ? `/ Connected to ${mediaPlan.persona.name}` : ''}</p>

            <div className="absolute right-0 top-0" style={{ marginRight: '10px', marginTop: '10px' }}>
              <button
                className="bg-desert-storm border-none circle cursor-pointer flex flex-center flex-justify-center"
                onClick={this.toggleBoxMenu}
                style={{ height: '32px', width: '32px' }}
                type="button"
              >
                <img alt="" className="block" src={iconDots} />
              </button>

              <CSSTransition
                in={boxMenuVisible}
                classNames="fade-transform-top"
                timeout={600}
                unmountOnExit
              >
                <div
                  className="absolute bg-white box-shadow-dropdown h5 mt-5 nowrap px-30 py-20 right-0 rounded-6 sfpro-regular triangle-top-right-24-white-5 top-100 z7"
                  style={{ marginRight: '-13px', minWidth: '205px' }}
                >
                  <a className="block mb-20 text-tuna" href={`/media_plans/${mediaPlan.id}`}>View</a>
                  <a className="block text-tuna" href={`/media_plans/${mediaPlan.id}/download`}>Download</a>
                </div>
              </CSSTransition>
            </div>

            <img alt="" className="block mb-10 mx-auto" src={mediaPlanPlaceholder} />

            <p className="center h2 text-tuna">Media Plan - {new Date(mediaPlan.created_at).toLocaleDateString('en-EN', { year: 'numeric', month: 'long', day: '2-digit' })}</p>

            <p className="center fs-13 mb-30 text-tuna">$<NumberFormat value={mediaPlan.budget} {...NumberFormatOptions} /> — {mediaPlan.country}</p>

            <div className="mb-40 mx-auto sm-flex-wrap sm-m0" style={{ maxWidth: '310px' }}>
              {mediaPlan.payed && <a
                className="btn btn--primary btn--outlined-wisp-pink btn--fs-13 btn--lh-32 mr-10 sm-col-12 sm-m0 sm-mb2"
                href={`/media_plans/${mediaPlan.id}`}
              >
                View
              </a>}

              {!mediaPlan.payed && canUnlock && <a
                className="btn btn--primary btn--fs-13 btn--lh-32 sm-col-12"
                onClick={this.unlockMediaplan}
              >
                Unlock
              </a>}

              {!mediaPlan.payed && !canUnlock && <a
                className="btn btn--primary btn--fs-13 btn--lh-32 sm-col-12"
                href={`/pricing`}
              >
                Purchase
              </a>}
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default MediaPlan
